import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Departments() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({ open: false, type: 'add', department: null });
  const [form, setForm] = useState({ name: '', code: '', head: '', description: '', status: 'active' });

  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('crm_token')}` });

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await axios.get('/api/clinic/departments', { headers: headers() });
      setDepartments(res.data || []);
    } catch (err) {
      console.error('Departments fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenAdd = () => {
    setForm({ name: '', code: '', head: '', description: '', status: 'active' });
    setModal({ open: true, type: 'add', department: null });
  };

  const handleOpenEdit = (dept) => {
    setForm({
      name: dept.name,
      code: dept.code || '',
      head: dept.head || '',
      description: dept.description || '',
      status: dept.is_active ? 'active' : 'inactive'
    });
    setModal({ open: true, type: 'edit', department: dept });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.code.trim()) {
      alert('Departman adı ve kodu zorunludur.');
      return;
    }

    const payload = {
      name: form.name,
      code: form.code.toUpperCase(),
      head: form.head || null,
      description: form.description,
      is_active: form.status === 'active' ? 1 : 0
    };

    try {
      if (modal.type === 'add') {
        await axios.post('/api/clinic/departments', payload, { headers: headers() });
      } else {
        await axios.put(`/api/clinic/departments/${modal.department.id}`, payload, { headers: headers() });
      }
      setModal({ open: false, type: 'add', department: null });
      fetchDepartments();
    } catch (err) {
      console.error('Department save error:', err);
      alert('Departman kaydedilemedi, lütfen tekrar deneyin.');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu departmanı silmek istediğinizden emin misiniz?')) return;
    try {
      await axios.delete(`/api/clinic/departments/${id}`, { headers: headers() });
      setDepartments(prev => prev.filter(d => d.id !== id));
    } catch (err) {
      console.error('Department delete error:', err);
      alert('Departman silinemedi, lütfen tekrar deneyin.');
    }
  };

  const totalDepts = departments.length;
  const activeDepts = departments.filter(d => d.is_active).length;

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">🩺 Departmanlar</h1>
          <p className="page-subtitle">Klinik branş ve departman yönetimi</p>
        </div>
        <button className="btn btn-primary" onClick={handleOpenAdd}>+ Yeni Departman</button>
      </div>

      {/* Stats Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', marginTop: '16px' }}>
        <div className="card" style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ fontSize: '32px', background: 'rgba(var(--tertiary-rgb), 0.1)', width: '60px', height: '60px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🏢</div>
          <div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff' }}>{totalDepts}</div>
            <div style={{ fontSize: '13px', color: '#64748b' }}>Toplam Departman</div>
          </div>
        </div>
        <div className="card" style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ fontSize: '32px', background: 'rgba(16, 185, 129, 0.1)', width: '60px', height: '60px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🟢</div>
          <div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#10B981' }}>{activeDepts}</div>
            <div style={{ fontSize: '13px', color: '#64748b' }}>Aktif Departmanlar</div>
          </div>
        </div>
      </div>

      {/* Departments Table */}
      <div className="card" style={{ marginTop: '20px' }}>
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Kod</th>
                <th>Departman Adı</th>
                <th>Departman Sorumlusu</th>
                <th>Açıklama</th>
                <th>Durum</th>
                <th style={{ textAlign: 'right' }}>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {departments.map(d => (
                <tr key={d.id}>
                  <td className="font-medium">
                    <span style={{ background: 'rgba(var(--tertiary-rgb), 0.15)', color: '#818cf8', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '700' }}>
                      {d.code || '-'}
                    </span>
                  </td>
                  <td className="font-medium" style={{ color: '#fff' }}>{d.name}</td>
                  <td>{d.head || 'Atanmadı'}</td>
                  <td style={{ maxWidth: '280px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#94a3b8' }}>
                    {d.description || '-'}
                  </td>
                  <td>
                    <span className="badge" style={{
                      background: d.is_active ? 'rgba(16, 185, 129, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                      color: d.is_active ? '#10B981' : '#EF4444'
                    }}>
                      {d.is_active ? 'Aktif' : 'Pasif'}
                    </span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <button className="btn btn-secondary" style={{ padding: '6px 12px', fontSize: '12.5px' }} onClick={() => handleOpenEdit(d)}>
                        Düzenle
                      </button>
                      <button className="btn btn-danger" style={{ padding: '6px 12px', fontSize: '12.5px', background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239, 68, 68, 0.2)' }} onClick={() => handleDelete(d.id)}>
                        Sil
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {departments.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center text-muted" style={{ padding: '40px' }}>
                    Henüz kayıtlı departman bulunmuyor.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal Add/Edit */}
      {modal.open && (
        <div className="modal-overlay" onClick={() => setModal({ ...modal, open: false })}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>{modal.type === 'add' ? 'Yeni Departman Ekle' : 'Departman Düzenle'}</h2>
              <button className="modal-close" onClick={() => setModal({ ...modal, open: false })}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div className="form-group">
                    <label className="form-label">Departman Adı *</label>
                    <input
                      type="text"
                      className="input"
                      value={form.name}
                      onChange={e => setForm({ ...form, name: e.target.value })}
                      placeholder="Örn: Kulak Burun Boğaz"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Departman Kodu (Kısa Ad) *</label>
                    <input
                      type="text"
                      className="input"
                      value={form.code}
                      onChange={e => setForm({ ...form, code: e.target.value })}
                      placeholder="Örn: KBB"
                      maxLength={5}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Departman Sorumlusu (Hekim)</label>
                    <input
                      type="text"
                      className="input"
                      value={form.head}
                      onChange={e => setForm({ ...form, head: e.target.value })}
                      placeholder="Örn: Dr. Ahmet Yılmaz"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Açıklama</label>
                    <textarea
                      className="textarea"
                      rows={3}
                      value={form.description}
                      onChange={e => setForm({ ...form, description: e.target.value })}
                      placeholder="Departman hakkında kısa bilgi..."
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Durum</label>
                    <select
                      className="input"
                      value={form.status}
                      onChange={e => setForm({ ...form, status: e.target.value })}
                      style={{ background: '#090a0f', color: '#fff' }}
                    >
                      <option value="active">Aktif</option>
                      <option value="inactive">Pasif</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setModal({ ...modal, open: false })}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Departments;
